/* eslint-disable @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
import { Controller } from "stimulus";

const storage_key = "dismissedBanners";

export default class Banner extends Controller<HTMLDivElement> {
	declare idValue: string;

	getStorageValue(): string[] {
		const ret = JSON.parse(localStorage.getItem(storage_key) || "[]") as string[];
		if (Array.isArray(ret)) {
			return ret;
		} else {
			return [];
		}
	}

	setStorageValue(ids: string[]): void {
		localStorage.setItem(storage_key, JSON.stringify(ids));
	}

	static values = {
		id: String,
	};

	shouldBeHidden() {
		return this.getActiveIDs().includes(this.idValue);
	}

	shouldBeVisible() {
		return !this.shouldBeHidden();
	}

	clearInactiveDismissals() {
		const new_values = this.getStorageValue()
			.map((s) => ({
				id: s.split(":::")[0],
				timestamp: s.split(":::")[1],
			}))
			.filter(({ timestamp }) => {
				if (!timestamp) {
					return false;
				}
				const d = new Date();
				d.setTime(parseInt(timestamp));
				const diff = Date.now() - d.getTime();
				if (diff > 1000 * 60 * 60 * 24 * 7) {
					return false;
				}
				return true;
			})
			.map(({ id, timestamp }) => `${id}:::${timestamp}`);
		this.setStorageValue(new_values);
	}

	getActiveIDs() {
		this.clearInactiveDismissals();
		return this.getStorageValue().map((e) => e.split(":::")[0]);
	}

	saveDismissal(id: string) {
		this.setStorageValue([...this.getStorageValue(), id + ":::" + Date.now()]);
	}

	hide = () => {
		const ids = this.getActiveIDs();
		if (!ids.includes(this.idValue)) {
			this.saveDismissal(this.idValue);
		}
		this.element.style.setProperty("height", "0");
		this.element.style.setProperty("min-height", "0");
		this.element.style.setProperty("overflow", "hidden");
	};

	clickHide(event?: MouseEvent) {
		this.hide();
		event?.preventDefault();
		document.dispatchEvent(new Event("banner-hidden"));
	}

	show() {
		this.element.style.setProperty("display", "flex");
	}

	connect() {
		document.addEventListener("banner-hidden", this.hide);
		if (this.shouldBeVisible()) {
			this.show();
		} else {
			this.hide();
		}
	}
}
